export const SIGNED_OUT_HEADER_BREAKPOINT = 975;
